// extracted by mini-css-extract-plugin
export default {"center":"loader_center__dtRFE","span":"loader_span__oBV8W","animate":"loader_animate__rvNgQ"};